import React from 'react';
import { Item, registry, RenderProps } from '../Item';
import { BUTTON } from '../itemIds';
import { Button, Link } from '~/ui/buttons';

interface Props {
  title: string;
  url: string;
  type?: string;
  display?: 'block' | 'inline' | 'flex' | 'inline-flex';
  showShadow?: boolean;
}

export class LinkButton extends Item<typeof BUTTON, Props> {
  protected render({
    title,
    url,
    type = 'button',
    display = 'block',
    showShadow
  }: RenderProps<Props>) {
    if (type === 'button') {
      return (
        <Button h={'46px'} onClick={() => window.open(url, '_blank')}>
          {title}
        </Button>
      );
    } else {
      return (
        <Link
          display={display}
          showShadow={showShadow}
          href={url}
          target="_blank"
        >
          {title}
        </Link>
      );
    }
  }
}

registry[BUTTON] = LinkButton;
